module.exports = __webpack_public_path__ + "img/photo-6.6fc9756a.jpg";